import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Header.css';
import { getImageUrl } from '../../utils/imageUtils';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost/ehaazri/api';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [logo, setLogo] = useState(getImageUrl('/images/logos/Teal text red Icon.png'));
  const [logoAlt, setLogoAlt] = useState('eHaazri Logo');
  const [registerLink, setRegisterLink] = useState('/haazri-frontend/#/register');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    fetchBranding();
  }, []);

  const fetchBranding = async () => {
    try {
      const response = await axios.get(`${API_URL}/landing_page_api.php`);
      if (response.data.status === 'success') {
        const config = response.data.data.config || {};

        if (config.site_logo) {
          setLogo(getImageUrl(config.site_logo));
        }

        if (config.site_logo_alt) {
          setLogoAlt(config.site_logo_alt);
        }

        if (config.link_register) {
          setRegisterLink(config.link_register);
        }
      }
    } catch (error) {
      console.error('Failed to fetch branding:', error);
    }
  };

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    setMobileMenuOpen(false);

    // If we're not on the homepage, navigate there first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // If we're already on the homepage, just scroll
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <nav className="container">
        <div className="nav-content">
          <Link to="/" className="logo">
            <img
              src={logo}
              alt={logoAlt}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </Link>

          <button
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span>{mobileMenuOpen ? '✕' : '☰'}</span>
          </button>

          <ul className={`nav-links ${mobileMenuOpen ? 'show' : ''}`}>
            <li>
              <a href="#features" onClick={(e) => handleSmoothScroll(e, 'features')}>
                Features
              </a>
            </li>
            <li>
              <a href="#how-it-works" onClick={(e) => handleSmoothScroll(e, 'how-it-works')}>
                How It Works
              </a>
            </li>
            <li>
              <a href="#testimonials" onClick={(e) => handleSmoothScroll(e, 'testimonials')}>
                Testimonials
              </a>
            </li>
            <li>
              <a href="#faq" onClick={(e) => handleSmoothScroll(e, 'faq')}>
                FAQ
              </a>
            </li>
            <li>
              <a href={registerLink} className="btn-register">
                Register
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
